import React, { Component } from "react";
import Logo from '../assets/leafnet-logo.jpg';
import '../root.css';
import axios from 'axios';
import api from '../config.json';
import swal from "sweetalert";
import valid from '../utill/validation';
import joi from 'joi';
import Loading from "../utill/LoadingComponent";
import { ToastContainer, toast } from 'react-toastify';
import { Input } from 'antd';
import AuthShell, { AuthField } from '../theme/AuthShell';
import { UI_NEW, getUiMode, subscribeUiMode } from '../theme/uiMode';
import TryNewUiButton from '../theme/TryNewUiButton';

class ForgotForm extends Component {
  state = {
    user: {},
    errors: {},
    querySuccess: false,
    step: 1, // Step 1: Enter email + company, Step 2: OTP, Step 3: Reset Password
    otp: '',
    newPassword: ''
  };

  schema = {
    email: joi.string().email().required(),
    company: joi.string().required()
  };

  handleOnChange = (e) => {
    const { name, value } = e.target;
    const user = { ...this.state.user };
    const errors = { ...this.state.errors };

    const errorMessage = valid.validateProperty(e.currentTarget, this.schema);
    if (errorMessage) errors[name] = errorMessage;
    else delete errors[name];

    user[name] = value;
    this.setState({ user, errors });
  };

  handleForgotClick = async () => {
    const errors = valid.validate(this.state.user, this.schema);
    this.setState({ errors: errors || {} });
    if (errors) return;

    try {
      this.setState({ querySuccess: true });

      await axios.patch(
        `${api.dataEntryUrl}forgetPassword`,
        { email: this.state.user.email },
        {
          headers: {
            company: this.state.user.company  // or wherever your company value is stored
          }
        }
      );

      this.setState({ step: 2, querySuccess: false });
      swal(
        "Success",
        "An OTP has been sent to your registered email address. Please check your inbox and enter the code to proceed.",
        "success"
      );

    } catch (err) {
      this.setState({ querySuccess: false });
      swal("Failed to send OTP");
    }
  };


  handleOtpChange = (e) => {
    const otp = e.target.value.replace(/\D/g, '').slice(0, 4);
    this.setState({ otp });
  };

  verifyOtp = async () => {
    const { email } = this.state.user;
    if (this.state.otp.length !== 4) {
      swal("OTP must be 4 digits");
      return;
    }

    try {
      await axios.patch(`${api.dataEntryUrl}verify-otp`, { email, otp: this.state.otp },

        {
          headers: {
            company: this.state.user.company  // or wherever your company value is stored
          }
        }
      );
      swal(
        "OTP Verified",
        "Your OTP has been successfully verified. Please enter your new password to continue.",
        "success"
      );

      this.setState({ step: 3 });
    } catch {
      swal("Invalid OTP");
    }
  };

  handlePasswordChange = (e) => {
    this.setState({ newPassword: e.target.value });
  };

  resetPassword = async () => {
    const { email } = this.state.user;
    const { newPassword } = this.state;

    if (!newPassword) {
      swal("Please enter a new password");
      return;
    }

    try {
      await axios.patch(`${api.dataEntryUrl}auth/reset-password`, {
        email,
        newPassword
      },

        {
          headers: {
            company: this.state.user.company  // or wherever your company value is stored
          }
        });
      swal("Password changed successfully");
      this.props.history.push('/');
    } catch {
      swal("Failed to reset password");
    }
  };

  renderStep = () => {
    const { step, user, errors, otp, newPassword } = this.state;

    if (step === 1) {
      return (
        <>
          <input
            type="text"
            id="login1"
            className="fadeIn1 second1"
            name="email"
            placeholder="Enter Email"
            onChange={this.handleOnChange}
          />
          {errors.email && <div className="alert small alert-danger">{errors.email}</div>}

          <input
            type="text"
            id="companyName"
            className="fadeIn1 fourth1"
            name="company"
            placeholder="Company Name"
            onChange={this.handleOnChange}
          />
          {errors.company && <div className="alert small alert-danger">{errors.company}</div>}

          <input
            type="submit"
            className="fadeIn1 fourth1"
            value="Send OTP"
            onClick={this.handleForgotClick}
          />
        </>
      );
    }

    if (step === 2) {
      return (
        <>
          <label>Enter 4-digit OTP</label>
          <Input
            maxLength={4}
            value={otp}
            onChange={this.handleOtpChange}
            style={{
              width: 150,
              textAlign: 'center',
              fontSize: '1.5em',
              letterSpacing: 8,
              marginBottom: 10
            }}
            placeholder="____"
          />
          <input
            type="submit"
            className="fadeIn1 fourth1"
            value="Verify OTP"
            onClick={this.verifyOtp}
          />
        </>
      );
    }

    if (step === 3) {
      return (
        <>
          <label>New Password</label>
          <Input.Password
            placeholder="Enter new password"
            value={newPassword}
            onChange={this.handlePasswordChange}
          />
          <input
            type="submit"
            className="fadeIn1 fourth1"
            value="Reset Password"
            onClick={this.resetPassword}
            style={{ marginTop: 10 }}
          />
        </>
      );
    }

    return null;
  };

  componentDidMount() {
    // Re-render when the look is switched from the sign-in frame.
    this.unsubscribeUiMode = subscribeUiMode(() => this.forceUpdate());
  }

  componentWillUnmount() {
    if (this.unsubscribeUiMode) this.unsubscribeUiMode();
  }

  // New UI: the same three steps and handlers as renderStep(), as labelled forms.
  renderNewStep = () => {
    const { step, user, errors, otp, newPassword } = this.state;
    const submitWith = (handler) => (e) => {
      e.preventDefault();
      handler();
    };
    const head = (title, sub) => (
      <div className="lnauth-head">
        <span className="lnauth-static-label">Step {step} of 3</span>
        <h1 className="lnauth-title">{title}</h1>
        <p className="lnauth-sub">{sub}</p>
      </div>
    );

    if (step === 1) {
      return (
        <form className="lnauth-form" onSubmit={submitWith(this.handleForgotClick)}>
          {head('Forgot your password?', "Enter your email and company, and we'll email you a code.")}
          <AuthField id="lnauth-email" label="Email" error={errors.email}>
            <input
              type="text"
              inputMode="email"
              id="lnauth-email"
              name="email"
              placeholder="you@company.com"
              autoComplete="username"
              aria-invalid={Boolean(errors.email)}
              aria-describedby={errors.email ? 'lnauth-email-error' : undefined}
              value={user.email || ''}
              onChange={this.handleOnChange}
            />
          </AuthField>
          <AuthField id="lnauth-company" label="Company" error={errors.company}>
            <input
              type="text"
              id="lnauth-company"
              name="company"
              placeholder="Company name"
              autoComplete="organization"
              aria-invalid={Boolean(errors.company)}
              aria-describedby={errors.company ? 'lnauth-company-error' : undefined}
              value={user.company || ''}
              onChange={this.handleOnChange}
            />
          </AuthField>
          <button type="submit" className="lnauth-submit">Send code</button>
        </form>
      );
    }

    if (step === 2) {
      return (
        <form className="lnauth-form" onSubmit={submitWith(this.verifyOtp)}>
          {head('Check your email', `Enter the 4-digit code we sent to ${user.email || 'your email'}.`)}
          <AuthField id="lnauth-otp" label="4-digit code">
            <input
              type="text"
              inputMode="numeric"
              id="lnauth-otp"
              maxLength={4}
              autoComplete="one-time-code"
              placeholder="____"
              className="lnauth-otp"
              value={otp}
              onChange={this.handleOtpChange}
            />
          </AuthField>
          <button type="submit" className="lnauth-submit">Verify code</button>
        </form>
      );
    }

    if (step === 3) {
      return (
        <form className="lnauth-form" onSubmit={submitWith(this.resetPassword)}>
          {head('Set a new password', `Choose a new password for ${user.email || 'your account'}.`)}
          <AuthField id="lnauth-new-password" label="New password">
            <input
              type="password"
              id="lnauth-new-password"
              placeholder="Enter new password"
              autoComplete="new-password"
              value={newPassword}
              onChange={this.handlePasswordChange}
            />
          </AuthField>
          <button type="submit" className="lnauth-submit">Reset password</button>
        </form>
      );
    }

    return null;
  };

  render() {
    if (getUiMode() === UI_NEW) {
      return (
        <AuthShell>
          <ToastContainer />
          {this.state.querySuccess ? <Loading /> : ''}
          {this.renderNewStep()}
          <div className="lnauth-back">
            <button type="button" className="lnauth-link" onClick={() => this.props.history.push('/')}>
              Back to sign in
            </button>
          </div>
        </AuthShell>
      );
    }

    return (
      <div className="wrapper1 fadeInDown1">
        <ToastContainer />
        {this.state.querySuccess ? <Loading /> : ''}

        <div id="formContent1">
          <div className="fadeIn1 first1">
            <img width={250} src={Logo} id="icon" alt="User Icon" style={{ display: 'inline' }} />
          </div>

          {this.renderStep()}

          <div id="formFooter1">
            <a className="underlineHover1" style={{ cursor: 'pointer' }} onClick={() => this.props.history.push('/')}>
              Back
            </a>
          </div>
        </div>

        <TryNewUiButton />
      </div>
    );
  }
}

export default ForgotForm;
